<script setup>
import { get_profile } from '@/services/user';
import { onMounted, ref } from 'vue';
import { humanizeText } from '@/helper';

const isLoading = ref(true)
const user = ref({})
onMounted(async ()=>{
    let response = await get_profile()
    user.value = response.result.data.data
    isLoading.value = false
})
</script>

<template>
<div class="col-xl-4">
    <div class="card">
        <div class="card-header ">
            <h4 class="card-title mb-0">My Profile</h4>
            <div class="card-options"><a class="card-options-collapse" href="javascript:void(0)" data-bs-toggle="card-collapse"><i class="fe fe-chevron-up"></i></a><a class="card-options-remove" href="javascript:void(0)" data-bs-toggle="card-remove"><i class="fe fe-x"></i></a></div>
        </div>
        <div class="card-body">
            <loadingCard v-if="isLoading" />
            <form v-else>
                <div class="row mb-2">
                    <div class="profile-title">
                        <div class="media">
                            <!-- <img class="img-70 rounded-circle" alt="" src="@/assets/images/user/7.jpg"> -->
                            <div class="media-body">
                                <router-link :to="{name: 'profile'}">
                                    <h5 class="mb-1 ">
                                        {{ user.attributes.first_name }} {{ user.attributes.last_name }}
                                    </h5>
                                </router-link>
                                <p class="text-capitalize">{{ humanizeText(user.attributes.user_type) }}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="mb-3">
                    <label class="form-label">Email Address</label>
                    <input class="form-control" placeholder="example@mail.com" :value="user.attributes.email" disabled>
                </div>
                <div class="mb-3">
                    <label class="form-label">Password</label>
                    <input class="form-control" type="password" value="password" :value="user.attributes.password">
                </div>
                <div class="form-footer d-flex justify-content-end">
                    <button class="btn btn-primary btn-block">Save</button>
                </div>
            </form>
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: 'sidePage'
}
</script>
